import { useState, useEffect } from 'react';
import { FiClock } from 'react-icons/fi';
import { FaCar, FaCheckCircle } from 'react-icons/fa';
import mainImg from '../Images/logo.jpg';
// import mainImg from '../Images/vps_parking.png';
import './Home.css';

const Home = () => {
  const [id, setID] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [ticketCalled, setTicketCalled] = useState(false);

  const getTicket = (ID) => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/publicApis/getTicket?transaction_id=${ID}`)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const callMyCar = () => {
    setSaveIsLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/publicApis/callVehicle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ transaction_id: id }),
    })
      .then(response => response.json())
      .then(data => {
        setSaveIsLoading(false);
        setTicketCalled(true);
      })
      .catch(error => {
        console.error(error);
        setSaveIsLoading(false);
      });
  };

  useEffect(() => {
    const getUrlParameter = (name) => {
      const params = new URLSearchParams(window.location.search);
      return params.get(name);
    };
    const idFromUrl = getUrlParameter('ID') || '123456'; // Default ID for demo
    if (idFromUrl) {
      setID(idFromUrl);
      getTicket(idFromUrl);
    }
  }, []);

  return (
    <div className="app-container">
      {/* Header with logos */}
      <header className="header">
        <div className="header-content">
          <div className="logo-container">
            {/* Replace with actual image path */}
            <img src={mainImg} alt="Parking" className="logo" />
          </div>
          <div className="logo-container">
            {/* Replace with actual image path */}
            {/* <img src={zeroLogo} alt="Zero4" className="logo" /> */}
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="main-content">
        <div className="ticket-container">
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading ticket information...</p>
            </div>
          ) : (
            <div className="ticket-content">
              <div className="ticket-header">
                <h1 className="ticket-title">Parking Ticket #{data?.serial_number || "000000"}</h1>
              </div>

              <div className="info-grid">
                <div className="info-card timing-card">
                  <h2 className="card-title">
                    <FiClock className="icon" /> Timing Details
                  </h2>
                  <div className="info-list">
                    <div className="info-item">
                      <span className="info-label">Entry:</span>
                      <span className="info-value">{data?.entry_str || "—"}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Exit:</span>
                      <span className="info-value">{data?.exit_str || "Pending"}</span>
                    </div>
                  </div>
                </div>

                <div className="info-card payment-card">
                  <h2 className="card-title">Payment Information</h2>
                  <div className="info-list">
                    <div className="info-item">
                      <span className="info-label">Status:</span>
                      <span className={`info-value ${data?.status === 'paid' ? 'status-paid' : 'status-unpaid'}`}>
                        {data?.status === 'paid' ? 'Paid' : 'Unpaid'}
                      </span>
                    </div>
                    {/* <div className="info-item">
                      <span className="info-label">Amount:</span>
                      <span className="info-value">{data?.paid_amount} L.L</span>
                    </div> */}
                  </div>
                </div>
              </div>

              {!ticketCalled ? (
                <div className="button-container">
                  <button
                    onClick={callMyCar}
                    disabled={saveIsLoading}
                    className="call-car-button"
                  >
                    {saveIsLoading ? (
                      <>
                        <div className="button-spinner"></div>
                        Processing...
                      </>
                    ) : (
                      <>
                        <FaCar className="button-icon" />
                        Call My Car
                      </>
                    )}
                  </button>
                </div>
              ) : (
                <div className="success-container">
                  <div className="success-icon-container">
                    <FaCheckCircle className="success-icon" />
                  </div>
                  <p className="success-title">Your car has been called!</p>
                  <p className="success-subtitle">Please proceed to the pickup area.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="copyright">&copy; {new Date().getFullYear()} {process.env.REACT_APP_NAME} Parking System. All rights reserved.</p>
          <p className="powered-by">Powered by DSOFT-LB</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;